module.exports = __webpack_public_path__ + "static/img/logs.8f77e28d.png";